import React from 'react';
import { CheckEmoji, LightningEmoji, MoneyBagEmoji, BriefcaseEmoji, SparklesEmoji } from './Emoji';
import { handleCheckout } from './CheckoutUtils';
export function PricingCard() {
  return <div className="bg-amber-50 rounded-xl overflow-hidden border border-amber-200 shadow-lg max-w-2xl mx-auto" data-id="element-405">
      {/* Header - Mejor Valor */}
      <div className="bg-amber-600 text-white text-center py-2 font-bold" data-id="element-406">
        Mejor Valor
      </div>
      {/* Main content */}
      <div className="p-6" data-id="element-407">
        {/* Collection title */}
        <h3 className="text-xl font-bold text-amber-800 text-center mb-4" data-id="element-408">
          Colección completa de ebooks: Picadas Fáciles con $2.000 +{' '}
          <span className="text-green-600" data-id="element-409">6 Bonos Exclusivos</span>
        </h3>
        {/* Product image */}
        <div className="mb-6" data-id="element-410">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iuYaVT8p6xKkxNtbTLS2h9/Generated_Image_September_13%2C_2025_-_7_39PM.png" alt="Colección completa de Picadas Fáciles" className="w-full h-auto rounded-lg" data-id="element-411" />
        </div>
        {/* Pricing table */}
        <div className="grid grid-cols-2 gap-2 mb-6" data-id="element-412">
          <div className="text-gray-700 font-medium" data-id="element-413">
            Método Picadas Fáciles™:
          </div>
          <div className="text-right text-amber-700 font-bold" data-id="element-414">ARS 17.990</div>
          <div className="text-gray-700 font-medium" data-id="element-415">
            6 Bonos Gratis incluidos:
          </div>
          <div className="text-right text-amber-700 font-bold" data-id="element-416">ARS 150.000</div>
          <div className="text-gray-700 font-bold text-lg pt-2 border-t border-amber-200" data-id="element-417">
            Valor Total:
          </div>
          <div className="text-right text-amber-700 font-bold text-lg pt-2 border-t border-amber-200" data-id="element-418">
            ARS 164.999
          </div>
        </div>
        {/* Special offer */}
        <div className="bg-amber-100 rounded-lg p-4 mb-6" data-id="element-419">
          <div className="text-center text-amber-800 font-bold text-lg mb-2" data-id="element-420">
            🚨 ¡OFERTA ESPECIAL HOY!
          </div>
          <div className="text-center text-green-600 font-bold text-3xl mb-2" data-id="element-421">
            ARS 17.990
          </div>
          <div className="text-center text-gray-700 mb-2" data-id="element-422">
            Método completo + 6 bonos premium
          </div>
          <div className="text-center text-amber-700 font-medium" data-id="element-423">
            👉 ¡Ahorrás ARS 150.000 comprando hoy!
          </div>
        </div>
        {/* Benefits */}
        <div className="space-y-2 mb-6" data-id="element-424">
          <div className="flex items-start gap-2" data-id="element-425">
            <CheckEmoji size={20} className="text-green-600" data-id="element-426" />
            <span className="text-gray-700" data-id="element-427">Recetas paso a paso</span>
          </div>
          <div className="flex items-start gap-2" data-id="element-428">
            <CheckEmoji size={20} className="text-green-600" data-id="element-429" />
            <span className="text-gray-700" data-id="element-430">
              Secretos de armado profesional
            </span>
          </div>
          <div className="flex items-start gap-2" data-id="element-431">
            <CheckEmoji size={20} className="text-green-600" data-id="element-432" />
            <span className="text-gray-700" data-id="element-433">
              Técnicas de presentación y ahorro
            </span>
          </div>
          <div className="flex items-start gap-2" data-id="element-434">
            <CheckEmoji size={20} className="text-green-600" data-id="element-435" />
            <span className="text-gray-700" data-id="element-436">Acceso inmediato en PDF</span>
          </div>
        </div>
        {/* Business Opportunity Section */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 mb-6" data-id="element-437">
          <h4 className="text-xl font-bold text-amber-800 text-center mb-4" data-id="element-438">
            <BriefcaseEmoji size={24} className="inline-block mr-2" data-id="element-439" />{' '}
            Oportunidad de Negocio Real
          </h4>
          <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-440">
            <div className="bg-white rounded-lg p-3 text-center shadow-sm" data-id="element-441">
              <div className="text-amber-700 font-bold text-xl mb-1" data-id="element-442">
                ARS 25.000
              </div>
              <div className="text-gray-600 text-sm" data-id="element-443">
                Valor promedio de una picada vendida
              </div>
            </div>
            <div className="bg-white rounded-lg p-3 text-center shadow-sm" data-id="element-444">
              <div className="text-amber-700 font-bold text-xl mb-1" data-id="element-445">10x</div>
              <div className="text-gray-600 text-sm" data-id="element-446">
                Retorno de inversión inmediato
              </div>
            </div>
            <div className="bg-white rounded-lg p-3 text-center shadow-sm" data-id="element-447">
              <div className="text-amber-700 font-bold text-xl mb-1" data-id="element-448">20+</div>
              <div className="text-gray-600 text-sm" data-id="element-449">
                Picadas vendidas por mes
              </div>
            </div>
            <div className="bg-white rounded-lg p-3 text-center shadow-sm" data-id="element-450">
              <div className="text-amber-700 font-bold text-xl mb-1" data-id="element-451">
                ARS 500.000
              </div>
              <div className="text-gray-600 text-sm" data-id="element-452">
                Ingresos mensuales potenciales
              </div>
            </div>
          </div>
          <div className="text-center mb-3" data-id="element-453">
            <div className="font-bold text-amber-800 mb-2" data-id="element-454">
              <span className="inline-block mr-1" data-id="element-455">
                <SparklesEmoji size={20} data-id="element-456" />
              </span>{' '}
              Convierte Tu Pasión en Negocio Rentable
            </div>
            <p className="text-gray-700 text-sm mb-3" data-id="element-457">
              Con solo una o dos picadas vendidas recuperás tu inversión. Ahora
              imaginá las posibilidades vendiendo 15, 20 o más cada mes.
            </p>
            <p className="text-amber-700 font-medium text-sm" data-id="element-458">
              👉 Picadas Fáciles™ te da el método, los precios y las técnicas
              para lograrlo.
            </p>
          </div>
        </div>
        {/* CTA Button */}
        <a href="#" className="checkout-fresh bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg transition-all transform hover:scale-105 w-full text-center inline-block" onClick={handleCheckout} data-id="element-459">
          👉 COMPRAR AHORA - AR$17.990
        </a>
      </div>
    </div>;
}